import { IDocumentEditable } from ".";
import { Section } from "../../../domain/document";
import {
  IDateLinkApplicable,
  IDateLinkRequestable,
  IItem,
  instanceOfIDateLinkApplicable,
  instanceOfIDateLinkRequestable,
  RelationalActionParameter
} from "../../../domain/document/items";

export class DateLinkExecutor {
  constructor(private _document: IDocumentEditable) {
  }

  public executeAll(): void {
    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; ++itemSetId) {
      const itemSet = this._document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        this.execute(item, itemSetId);
      }
    }
  }

  public execute(pasteSource: IItem, itemSetId: number): void {
    if (!instanceOfIDateLinkRequestable(pasteSource)) { return; }
    if (!pasteSource.dateLinkDestinations || pasteSource.dateLinkDestinations.length === 0) { return; }
    
    for (const destination of pasteSource.dateLinkDestinations) {
      // 徳大はpageKeyがnullになっているので注意すること
      const section = this._document.sections
        .filter(s => s.itemSetId === itemSetId && (s.pageKey != null) && s.pageKey === destination.pageKey)
        .pop();
      if (section) {
        // まずは指定されたpageKeyのsectionでマッチするオブジェクトが無いかどうかを調べる
        const result = this.executePasteToSectionItem(pasteSource, section, destination);
        if (result) { continue; }
      }
      // pageKeyでマッチするオブジェクトが無い場合は全てのページのマッチするオブジェクトに適用する
      this.executePasteToTarget(pasteSource, itemSetId, destination);
    }
  }

  private executePasteToSectionItem(pasteSource: IDateLinkRequestable, section: Section, destination: RelationalActionParameter): boolean {
    let result = false;
    for (const privateId of section.itemPrivateIds) {
      const item = this._document.itemSets[section.itemSetId].items[privateId];
      if (!instanceOfIDateLinkApplicable(item)) { continue; }
      if (pasteSource.privateId === item.privateId) { continue; }
      if (item.isDateLinkKeyMatch(destination)) {
        const cloned = item.clone() as IDateLinkApplicable;
        pasteSource.applyDateTo(cloned);
        this._document.updateItem(cloned, {
          itemSetId: section.itemSetId,
          reflexive: true,
        });
        result = true;
      }
    }
    return result;
  }

  private executePasteToTarget(pasteSource: IDateLinkRequestable, itemSetId: number, destination: RelationalActionParameter): void {
    const items = this._document.itemSets[itemSetId].items;
    for (const item of items) {
      if (!instanceOfIDateLinkApplicable(item)) { continue; }
      if (pasteSource.privateId === item.privateId) { continue; }
      if (item.isDateLinkKeyMatch(destination)) {
        const cloned = item.clone() as IDateLinkApplicable;
        pasteSource.applyDateTo(cloned);
        this._document.updateItem(cloned, {
          itemSetId,
          reflexive: true,
        });
      }
    }
  }
}
